var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reports"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('MENU.REPORTS')))]),_vm._l((_vm.documents),function(document,index){return _c('p',{key:index},[_c('a',{attrs:{"href":document.link,"target":"_blank"}},[_vm._v(_vm._s(document.title))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }